<div class="filter-container">
    <div class="filter-title">
      {{ 'Filter By:' }}
    </div>
  
    <!-- Type Dropdown -->
    <owc-select-dropdown
      [value]="typeSelVal"
      [limit]="4"
      [placeholder]="'Type'"
      [showApplyButton]="true"
      [multiple]="(filterOptions.types).length > 0"
      [disabled]="(filterOptions.types).length < 1 && !filterOptions.types[0]"
      (valueChange)="typeListValue($event)"
      [ngClass]="{'filter-selected': typeSelVal && typeSelVal.length > 0}"
      rounded
    >
    @for (item of filterOptions.types; track item) {
        <owc-list-item [value]="item">
            {{item}}
        </owc-list-item>
    }
    </owc-select-dropdown>
  
    <!-- Status Dropdown -->
    <owc-select-dropdown
      [value]="statusSelVal"
      [limit]="4"
      [placeholder]="'Status'"
      [showApplyButton]="true"
      [multiple]="(filterOptions.statuses).length > 0"
      [disabled]="(filterOptions.statuses).length < 1 && !filterOptions.statuses[0]"
      (valueChange)="statusListValue($event)"
      [ngClass]="{'filter-selected': statusSelVal && statusSelVal.length > 0}"
      rounded
    >
    @for (item of filterOptions.statuses; track item) {
        <owc-list-item [value]="item">
            {{item}}
        </owc-list-item>
    }

    </owc-select-dropdown>
  
    <!-- Country Dropdown -->
    <owc-select-dropdown
      [value]="countrySelVal"
      [limit]="4"
      [placeholder]="'Country'"
      [showApplyButton]="true"
      [multiple]="(filterOptions.country).length > 0"
      [disabled]="(filterOptions.country).length < 1 && !filterOptions.country[0]"
      (valueChange)="countryListValue($event)"
      [ngClass]="{'filter-selected': countrySelVal && countrySelVal.length > 0}"
      rounded
    >
    @for (item of filterOptions.country; track item) {
        <owc-list-item [value]="item">
            {{item}}
        </owc-list-item>
    }
    </owc-select-dropdown>
  
   
    <owc-button *ngIf="isClearVis" variant="secondary" (click)="clear()" rounded>
      Clear
    </owc-button>
  </div>
  